<template>
  <b-form @submit.prevent="submit">
    <b-card class="box-shadow2" :class="{ 'bg-dark text-light border-secondary': isDarkMode }">
      <div v-for="(item, index) in items" :key="index" class="mb-3">
        <b-form-group :label="isEdit ? 'Remark' : `Remark ${index + 1}`">
          <b-form-textarea v-model.trim="item.message" rows="3" required placeholder="Enter closure remark" />
        </b-form-group>
        <b-form-checkbox v-model="item.isActive">Active</b-form-checkbox>
        <b-button v-if="!isEdit && items.length > 1" size="sm" variant="outline-danger" class="mt-2" @click="items.splice(index, 1)">Remove</b-button>
      </div>
      <b-button v-if="!isEdit" size="sm" variant="outline-success" class="mb-3" @click="items.push({ message: '', isActive: true })">Add another remark</b-button>
      <div>
        <b-button type="submit" :variant="isDarkMode ? 'primary' : 'success'" :disabled="loading || !valid">{{ isEdit ? 'Update' : 'Create' }}</b-button>
        <b-button class="ml-2" variant="outline-secondary" @click="$router.push('/qms/closure-remarks')">Cancel</b-button>
      </div>
    </b-card>
  </b-form>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ClosureRemarksFormBox',
  props: { initial: { type: Object, default: null }, isEdit: Boolean, loading: Boolean },
  data() { return { items: [{ message: '', isActive: true }] }; },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    valid() { return this.items.every(item => item.message.trim()); }
  },
  watch: {
    initial: { immediate: true, handler(value) { if (value) this.items = [{ message: value.message || '', isActive: value.isActive !== false }]; } }
  },
  methods: { submit() { if (this.valid) this.$emit('submit', this.items); } }
};
</script>
